'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgWelloPoint } from '@common/icon';
import { useAdpopcorn } from '@/modules/adpopcorn';
import type { ShortcutActionRowProps } from './KosafHouseholdShortcutRow';
export const WelloPointRewardShortcutRow = t0 => {
  const $ = _c(12);
  const {
    label,
    onNavigate
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      placement: "MY_ENTRY"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    status,
    isExternalWebview,
    onClick,
    isOpening
  } = useAdpopcorn(t1);
  if (isExternalWebview) {
    return null;
  }
  let t2;
  if ($[1] !== onClick || $[2] !== onNavigate || $[3] !== status) {
    t2 = () => {
      onClick();
      if (status === "ready") {
        onNavigate?.();
      }
    };
    $[1] = onClick;
    $[2] = onNavigate;
    $[3] = status;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClick = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SvgWelloPoint originalFill={true} className="size-24 shrink-0" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== label) {
    t4 = <span className="line-clamp-1 font-500 text-Gray-900 typo-body3">{label}</span>;
    $[6] = label;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== handleClick || $[9] !== isOpening || $[10] !== t4) {
    t5 = <button type="button" onClick={handleClick} disabled={isOpening} className="flex w-full items-center gap-8 px-20 py-12 text-left transition-colors hover:bg-Gray-50 disabled:opacity-60">{t3}{t4}</button>;
    $[8] = handleClick;
    $[9] = isOpening;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};